import { Flex } from "@chakra-ui/react"
import { withPrefix } from "gatsby"
import React from "react"
import { useImagePicker } from "../desktop/hooks/useImagePicker"
import { useCloudProviderContext } from "../hooks/useCloudProviderContext"
import CloudProviderSelectionButtonMobile from "./CloudProviderSelectionButtonMobile"

interface Props {}

const CloudBrowserTabBar: React.FC<Props> = () => {
  const {
    setCurrentCloudProvider,
    currentCloudProvider,
    imageRegionId,
    lineItemId,
    productId,
    closeCloudProviderModal,
    setIsImportingImages,
  } = useCloudProviderContext()

  const onStartImporting = () => {
    setIsImportingImages(true)
  }

  const onCompleteImporting = () => {
    setIsImportingImages(false)
    closeCloudProviderModal()
  }

  const { getInputProps, openImagePicker } = useImagePicker({
    onCompleteImporting,
    onStartImporting,
    imageRegionId,
    lineItemId,
    productId,
  })

  return (
    <Flex alignItems="center" justifyContent="center" gap={2} py={4}>
      <>
        <CloudProviderSelectionButtonMobile
          logo={withPrefix("/images/cloud-providers/desktop/desktop.svg")}
          label="Your Device"
          isSelected={currentCloudProvider === "your-device"}
          className="cloud-provider-your-device-button"
          onClick={() => {
            setCurrentCloudProvider("your-device")
            openImagePicker()
          }}
        />
        <input {...getInputProps()} />
      </>
      <CloudProviderSelectionButtonMobile
        logo={withPrefix("/images/cloud-providers/vnz/ic_verizon-v.svg")}
        label="Verizon Cloud"
        isSelected={currentCloudProvider === "verizon-cloud"}
        className="cloud-provider-verizon-cloud-button"
        onClick={() => setCurrentCloudProvider("verizon-cloud")}
      />
    </Flex>
  )
}

export default CloudBrowserTabBar
